import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Form } from 'foundations-components/transitional/components/Form';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { AbstractProgress } from 'foundations-components/transitional/components/AbstractProgress';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import styled, { useTheme } from 'styled-components';
import { useSubscription } from '../../../hooks/useSubscription';
import { TEST_IDS, URLS } from '../../../utils/constants';
import { handleError } from '../../../utils/errorHandling';
import { RedAlertBanner } from '../components/RedAlertBanner';
import { useUpdatePaymentMethodMutation } from './useUpdatePaymentMethodMutation';
import { useUpdatePaymentMethodQuery } from './useUpdatePaymentMethodQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledPastDueCopy = styled.div.withConfig({
  displayName: "UpdatePaymentMethodModal__StyledPastDueCopy",
  componentId: "lzsgpc-0"
})(({
  theme
}) => `
  border: 1px solid ${theme.color['border-interactive-default']};
  padding: 10px 20px;

`);
export function UpdatePaymentMethodModal({
  objectId,
  actions
}) {
  const theme = useTheme();
  const {
    close
  } = actions;
  const {
    buyer,
    checkoutEmail
  } = useSubscription();
  const doesNotHaveBuyerEmail = !(buyer !== null && buyer !== void 0 && buyer.email);
  const customerEmail = doesNotHaveBuyerEmail ? checkoutEmail : buyer.email;
  const {
    data: queryData,
    loading: queryLoading
  } = useUpdatePaymentMethodQuery(objectId);
  const [onSubmit, {
    loading: submitLoading
  }] = useUpdatePaymentMethodMutation(objectId, customerEmail, () => {
    close();
    actions.revalidate().catch(handleError);
  });
  if (queryLoading || !queryData) {
    return /*#__PURE__*/_jsxs(Modal, {
      "data-test-id": TEST_IDS.UpdatePaymentMethod,
      size: "auto",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          paddingBlock: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.title"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: close
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(AbstractProgress, {
            Component: NanoProgress,
            maximum: 35
          }), /*#__PURE__*/_jsx(LoadingSpinner, {
            size: "small",
            minHeight: 100,
            layout: "centered",
            grow: true,
            showLabel: true,
            "data-test-id": "update-payment-method-modal:loading",
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "subscriptions.UpdatePaymentMethodModal.loadingMessage"
            })
          })]
        })
      })]
    });
  }
  const {
    order
  } = queryData;
  return /*#__PURE__*/_jsx(Modal, {
    "data-test-id": TEST_IDS.UpdatePaymentMethod,
    children: /*#__PURE__*/_jsxs(Form, {
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          paddingBlock: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.title"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: close
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [doesNotHaveBuyerEmail ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(RedAlertBanner, {
            message: "subscriptions.NoAssociatedContactEmailAlert.modalMessage"
          }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.description_jsx",
            options: {
              customerEmail
            },
            "data-test-id": "submit-update-payment-method-copy"
          })]
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'subscriptions.UpdatePaymentMethodModal.description',
          "data-test-id": "submit-update-payment-method-copy"
        }), /*#__PURE__*/_jsx(List, {
          styled: true,
          paddingInlineStart: "600",
          marginBlockStart: "400",
          wrapChildren: true,
          children: order.subscriptionNames.map(subscriptionName => /*#__PURE__*/_jsx("span", {
            children: subscriptionName
          }, subscriptionName))
        }), order.anyPastDue ? /*#__PURE__*/_jsx(StyledPastDueCopy, {
          theme: theme,
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.pastDue_jsx",
            options: {
              href: URLS.KBUpdatePaymentMethod
            },
            elements: {
              Link
            },
            "data-test-id": "submit-update-payment-method-past-due-copy"
          })
        }) : /*#__PURE__*/_jsx(Link, {
          href: URLS.KBUpdatePaymentMethod,
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.exampleLinkText"
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          "data-test-id": `${TEST_IDS.UpdatePaymentMethod}:submit`,
          loading: submitLoading,
          use: "primary",
          onClick: () => {
            onSubmit().catch(e => handleError(e));
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.sendLink"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": `${TEST_IDS.UpdatePaymentMethod}:cancel`,
          use: "secondary",
          onClick: close,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.cancel"
          })
        })]
      })]
    })
  });
}